export default {"src":"/login-app/[GIT_HASH]/_next/static/media/chart_line.1de38d4b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};